import React from 'react';
import WarehouseOpsPage from './WarehouseOpsPage';
export default function WarehouseTransferPage() {
  return <WarehouseOpsPage mode="transfer" title="Warehouse Transfer" subtitle="Move stock between warehouses" />;
}
